export const ValidationErrorMessages = {
  REQUIRED: 'Campo obbligatorio!',
  POSITIVE: 'Inserire un valore positivo!',
  NOT_ZERO: 'Inserire un valore maggiore di 0!',
  TYPE_NUMERIC: 'Il valore deve essere numerico!',
  EMAIL: "Inserire un'email valida!",
  INTEGER: 'Inserire solo numeri interi!',
};
